import React from 'react'
import PropTypes from 'prop-types'
import FireRollCallRow from './FireRollCallRow'

class FireRollCallGrid extends React.Component {
  constructor() {
    super()
    this.toggleSelect = this.toggleSelect.bind(this)
  }

  toggleSelect(checked) {
    this.props.handleCheckboxChange(checked)
  }

  render() {
    const rows = []
    const autoSignedOutRows = []

    this.props.fireRollCallData.forEach((fireRoll) => {
      if (!fireRoll.timeOut) {
        rows.push(<FireRollCallRow key={fireRoll.rowNumber} row={fireRoll} handleCheckboxChange={checked => this.toggleSelect(checked)} />)
      } else {
        autoSignedOutRows.push(<FireRollCallRow key={fireRoll.rowNumber} row={fireRoll} handleCheckboxChange={checked => this.toggleSelect(checked)} />)
      }
    })

    return (
      <div className="ln-c-table-container">
        {(rows.length === 0 ?
          <h3 className="ln-c-card ln-u-soft-top c-test">
            Auto signed out of site (after 12 hours)
          </h3>
          : '')}
        <table className="ln-c-table ln-c-table--responsive@md c-fire-roll-call-bottom-padding">
          <thead className="ln-c-table__header">
            <tr className="ln-c-table__row ln-c-table__header_row">
              <th className="ln-c-table__header-cell" />
              <th className="ln-c-table__header-cell">Name</th>
              <th className="ln-c-table__header-cell">Telephone</th>
              <th className="ln-c-table__header-cell">Company</th>
              <th className="ln-c-table__header-cell">In</th>
              <th className="ln-c-table__header-cell">Out</th>
            </tr>
          </thead>
          <tbody className="ln-c-table__body">
            {rows}
          </tbody>
          {(autoSignedOutRows.length > 0 ?
            <tbody className="ln-c-table__body">
              {rows.length > 0 ?
                <tr className="ln-c-table__row">
                  <td colSpan="6">
                    <h3 className="ln-c-card ln-u-soft-top">
                      Auto signed out of site (after 12 hours) <hr className="ln-c-rule" />
                    </h3>
                  </td>
                </tr> : ''}
              {autoSignedOutRows}
            </tbody>
            : '')}
        </table>
      </div>
    )
  }
}

FireRollCallGrid.propTypes = {
  fireRollCallData: PropTypes.arrayOf(
    PropTypes.shape({
      rowNumber: PropTypes.number.isRequired
    })
  ).isRequired,
  handleCheckboxChange: PropTypes.func.isRequired
}

export default FireRollCallGrid



// WEBPACK FOOTER //
// ./src/components/FireRollCall/FireRollCallGrid/index.jsx